export const getIpv4Address = async (): Promise<{ ip: string }> =>
  (await fetch('https://api.ipify.org/?format=json')).json();

export const getIpv6Address = async (): Promise<{ ip: string }> =>
  (await fetch('https://api64.ipify.org?format=json')).json();
